<template>

  <div v-if="checkPermission(c_permission)" class="d-inline">
    <b-tooltip v-if="disabled" :target="component_id" :title="$t('DOWNLOAD_NOT_POSSIBLE')" placement="top"></b-tooltip>
    <span :id="component_id"></span>
    <b-button  style="white-space: nowrap;"  @click.prevent="$emit('click')" size="sm" :variant="variant"  :disabled="disabled">
      <i class="appEdit" :class="{'fa fa-download fa-fw' : !loading, 'fa fa-spinner fa-spin fa-fw' : loading}"
         aria-hidden="true"></i>
      <slot></slot>
    </b-button>
  </div>
</template>

<script>
    export default {
        name: "AppDownload",
        data(){
          return {
            component_id: null,
          }
        },
        props: {
            loading: {
                type: Boolean,
                default: false
            },
            c_permission: {
                type: Number
            },
          disabled:{
            type:Boolean,
            default:false
          },
          variant: {
            type: String,
            default: 'primary'
          },
        },
      created(){
        this.component_id = 'DownloadButton_' + this._uid
      }

    }
</script>

<style scoped>

</style>
